import Vue from "vue";
import Router from "vue-router";
import Login from "../components/login/Login";
import Viewer from "../components/viewer/Viewer";
import ResetPassword from "../components/login/ResetPassword";
import {store} from "../store/store";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/reset-password/:token",
      name: "resetPassword",
      component: ResetPassword
    },
    {
      path: "/log_in",
      name: "login",
      component: Login
    },
    {
      path: "/viewer",
      name: "viewer",
      component: Viewer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/",
      redirect: "/viewer"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if(!from.name) {
      store.dispatch("getUser");
    }
    if(to.name == from.name) {
      next();
    } else {
      store.dispatch("checkToken").then(r => {
        if(store.getters.getToken.length < 1 || !r) {
          next({name: "login"});
        } else {
          store.commit("setCurrentBookmark", "start");
          next();
        }
      });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js